import Component from './component'

export default Component



// WEBPACK FOOTER //
// ./src/components/SearchCriteriaBadges/index.js